/**
 * Created by DejanK on 4/5/2017.
 *
 * All Single Bid Actions
 */
import get from 'lodash/get';
import {shouldAllowBuyerDraftNegotiations} from 'rfp/bid-manager/main/core/actions/buyer-draft-negotiations';

export default BidManagerSingleBidActionsService

BidManagerSingleBidActionsService.$inject = [ 'BidManagerActionsFactory' ];

function BidManagerSingleBidActionsService( BidManagerActionsFactory ) {
  const
    BUYER = 'BUYER',
    SUPPLIER = 'SUPPLIER',
    $service = this;

  $service.getActions = getActions;

  function getActions(bid, view) {
    const bidReport = {
      bids: [ bid ],
      bidsIds: [ bid._id ],
      view,
      statuses: [ bid.state.status ],
      sharedRfp: bid.rfp._id,
      user: view.side,
      userAccountType: view.userAccountType,
      rfpType: view.rfpType,
      viewType: view.type,
      chain: get(bid, 'supplier.company.chain.master._id'),
      isCompetitive: bid.isCompetitive
    };

    return bidReport.rfpType === 'HOTEL' ? getHotelRfpActions(bidReport) : {};
  }

  function addAction(actionArray, actionFn, bidReport){
    const action = actionFn(bidReport);
    if(!action.isAvailable || action.isAvailable()) {
      actionArray.push(action);
    }
  }

  function getHotelRfpActions(bidReport) {
    const user = bidReport.user;
    let actions = {};

    if (user === BUYER) { actions = getBuyerHotelRfpActions(bidReport) }
    else if (user === SUPPLIER) { actions = (bidReport.userAccountType === 'HMC'? getHmcHotelRfpActions: getSupplierHotelRfpActions)(bidReport) }
    return actions;
  }

  function getBuyerHotelRfpActions(bidReport) {
    const primaryActions = [], secondaryActions = [], otherActions = [], rfpActions = [];

    addAction(secondaryActions, BidManagerActionsFactory.deleteBid, bidReport);
    addAction(secondaryActions, BidManagerActionsFactory.resetBids, bidReport);
    addAction(secondaryActions, BidManagerActionsFactory.setContact(), bidReport);
    addAction(otherActions, BidManagerActionsFactory.changeTravelDestination, bidReport);

    switch (bidReport.statuses[0]) {

      case 'CREATED': // Bid Not Sent
        addAction(primaryActions, BidManagerActionsFactory.sendBid(), bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid(), bidReport);
        addAction(otherActions, BidManagerActionsFactory.editBid, bidReport);
        addAction(rfpActions, BidManagerActionsFactory.editRfp, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.createManualEntry(), bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.uploadResponses({side:'BUYER'}), bidReport);
        break;

      case 'SENT': // Bid Sent : Bid Received
        addAction(primaryActions, BidManagerActionsFactory.sendBid({label: 'Resend Bid'}), bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.withdrawBid, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid(), bidReport);
        addAction(otherActions, BidManagerActionsFactory.editBid, bidReport);
        addAction(rfpActions, BidManagerActionsFactory.editRfp, bidReport);
        addAction(otherActions, BidManagerActionsFactory.sendReminder, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.createManualEntry(), bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.uploadResponses({side:'BUYER'}), bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.copyBidLink, bidReport);
        break;

      case 'WITHDRAWN':
        addAction(otherActions, BidManagerActionsFactory.previewBid(), bidReport);
        addAction(rfpActions, BidManagerActionsFactory.editRfp, bidReport);
        break;

      case 'NOT_INTERESTED': // Decline To Bid
        addAction(primaryActions, BidManagerActionsFactory.sendBid(), bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.copyBidLink, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid(), bidReport);
        addAction(otherActions, BidManagerActionsFactory.editBid, bidReport);
        addAction(rfpActions, BidManagerActionsFactory.editRfp, bidReport);
        break;

      case 'RECEIVED':
        addAction(primaryActions, BidManagerActionsFactory.sendBid({label: 'Resend Bid'}), bidReport);
        addAction(primaryActions, BidManagerActionsFactory.setContact(), bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.withdrawBid, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid(), bidReport);
        addAction(otherActions, BidManagerActionsFactory.editBid, bidReport);
        addAction(rfpActions, BidManagerActionsFactory.editRfp, bidReport);
        addAction(otherActions, BidManagerActionsFactory.sendReminder, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.createManualEntry(), bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.uploadResponses({side:'BUYER'}), bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.copyBidLink, bidReport);
        break;

      case 'BUYER_DRAFT':
        addAction(primaryActions, BidManagerActionsFactory.createManualEntry(), bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.uploadResponses({side:'BUYER'}), bidReport);
        addAction(primaryActions, BidManagerActionsFactory.sendFinalAgreement, bidReport);
        if(shouldAllowBuyerDraftNegotiations(bidReport)) {
          addAction(secondaryActions, BidManagerActionsFactory.openNegotiations, bidReport);
          addAction(secondaryActions, BidManagerActionsFactory.uploadNegotiations, bidReport);
        }
        break;

      case 'RESPONDED': // Bid Responded
        addAction(primaryActions, BidManagerActionsFactory.sendFinalAgreement, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.withdrawBid, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.sendTotelDirectory, bidReport);

        addAction(primaryActions, BidManagerActionsFactory.openNegotiations, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.uploadNegotiations, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.setFinalAgreementPending, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.sendNoThankYouLetters, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.setNoThankYouPending, bidReport);

        addAction(otherActions, BidManagerActionsFactory.previewBid(), bidReport);
        addAction(otherActions, BidManagerActionsFactory.editBid, bidReport);

        addAction(rfpActions, BidManagerActionsFactory.editRfp, bidReport);
        break;

      case 'FINAL_AGREEMENT': // Final Agreement Sent/Received
        addAction(primaryActions, BidManagerActionsFactory.editFinalAgreement({label: 'View Final Agreement'}), bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.resendFinalAgreements, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.requestRateLoading, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.markRatesAsLoaded, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.markRatesAsNotLoaded, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.openNegotiations, bidReport);

        addAction(otherActions, BidManagerActionsFactory.previewBid(), bidReport);
        addAction(otherActions, BidManagerActionsFactory.editBid, bidReport);
        addAction(rfpActions, BidManagerActionsFactory.editRfp, bidReport);
        break;

      case 'NEGOTIATION_SENT': // Negotiation Sent/Received
      case 'NEGOTIATION_RESPONDED':
        addAction(primaryActions, BidManagerActionsFactory.openNegotiations, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.uploadNegotiations, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.reUploadNegotiations, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.resendNegotiationRequests, bidReport); // TODO: TEST SUPPLIER SIDE; TEST NEG RESPONSE
        addAction(secondaryActions, BidManagerActionsFactory.sendNoThankYouLetters, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid(), bidReport);
        addAction(otherActions, BidManagerActionsFactory.editBid, bidReport);
        addAction(rfpActions, BidManagerActionsFactory.editRfp, bidReport);
        break;

      case 'NO_LONGER_INTERESTED': // Participation Declined
        addAction(primaryActions, BidManagerActionsFactory.openNegotiations, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.sendNoThankYouLetters, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid(), bidReport);
        addAction(otherActions, BidManagerActionsFactory.editBid, bidReport);
        addAction(otherActions, BidManagerActionsFactory.setFinalAgreementPending, bidReport);
        addAction(otherActions, BidManagerActionsFactory.setNoThankYouPending, bidReport);

        addAction(rfpActions, BidManagerActionsFactory.editRfp, bidReport);
        break;

      case 'NEGOTIATION_FINALIZED':
        addAction(primaryActions, BidManagerActionsFactory.sendFinalAgreement, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.openNegotiations, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.setFinalAgreementPending, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.sendNoThankYouLetters, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.setNoThankYouPending, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid(), bidReport);
        addAction(otherActions, BidManagerActionsFactory.editBid, bidReport);
        addAction(rfpActions, BidManagerActionsFactory.editRfp, bidReport);
        break;

      case 'FINAL_AGREEMENT_PENDING':
        addAction(primaryActions, BidManagerActionsFactory.sendFinalAgreement, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.setNoThankYouPending, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.openNegotiations, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid(), bidReport);
        addAction(otherActions, BidManagerActionsFactory.editBid, bidReport);
        addAction(rfpActions, BidManagerActionsFactory.editRfp, bidReport);
        break;

      case 'NO_THANK_YOU_PENDING':
        addAction(primaryActions, BidManagerActionsFactory.sendNoThankYouLetters, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.setFinalAgreementPending, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.sendFinalAgreement, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.openNegotiations, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid(), bidReport);
        addAction(otherActions, BidManagerActionsFactory.editBid, bidReport);
        addAction(rfpActions, BidManagerActionsFactory.editRfp, bidReport);
        break;

      case 'NO_THANK_YOU': // No Thank You  Sent/Received
        addAction(primaryActions, BidManagerActionsFactory.viewNoThankYouLetter, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.sendFinalAgreement, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid(), bidReport);
        addAction(rfpActions, BidManagerActionsFactory.editRfp, bidReport);
        break;

      case 'COMPETITIVE_RESPONDED':
        addAction(primaryActions, BidManagerActionsFactory.acceptCompetitiveBid, bidReport);
        addAction(primaryActions, BidManagerActionsFactory.refuseCompetitiveBid, bidReport);
        break;

      default:
    }

    addAction(otherActions, BidManagerActionsFactory.setBidsRateAccessCode, bidReport);


    return {
      primary: primaryActions,
      secondary: secondaryActions,
      other: otherActions,
      rfp: rfpActions
    };
  }

  function getSupplierHotelRfpActions(bidReport) {
    const primaryActions = [], secondaryActions = [], otherActions = [], rfpActions = [];

    switch (bidReport.statuses[0]) {

      case 'CREATED':
        break;

      case 'SENT':
        addAction(primaryActions, BidManagerActionsFactory.previewBid({ label: 'View Bid' }), bidReport);
        addAction(primaryActions, BidManagerActionsFactory.createEditResponse(), bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.uploadResponses(), bidReport);
        // addAction(secondaryActions, BidManagerActionsFactory.declineBid, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.sendNotInterested, bidReport);
        // addAction(otherActions, BidManagerActionsFactory.forwardToNationalSales(), bidReport);
        break;

      case 'RECEIVED': {
        const isResponseValid =
          bidReport.bids.length > 0 && get(bidReport.bids[0], 'state.properties.isValid', false);
        if(isResponseValid){
          addAction(primaryActions, BidManagerActionsFactory.sendResponses, bidReport);
          addAction(primaryActions, BidManagerActionsFactory.createEditResponse(), bidReport);
          addAction(secondaryActions, BidManagerActionsFactory.uploadResponses(), bidReport);
        } else {
          addAction(primaryActions, BidManagerActionsFactory.createEditResponse(), bidReport);
          addAction(primaryActions, BidManagerActionsFactory.uploadResponses(), bidReport);
          addAction(secondaryActions, BidManagerActionsFactory.sendResponses, bidReport);
        }
        addAction(secondaryActions, BidManagerActionsFactory.sendNotInterested, bidReport);
        // addAction(secondaryActions, BidManagerActionsFactory.declineBid, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid({label: 'Preview Initial Bid'}), bidReport);
        addAction(otherActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        // addAction(otherActions, BidManagerActionsFactory.forwardToNationalSales(), bidReport);
        break;
      }
      case 'WITHDRAWN':
        addAction(otherActions, BidManagerActionsFactory.previewBid({ label: 'Preview Initial Bid' }), bidReport);
        addAction(otherActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'NOT_INTERESTED':
        addAction(primaryActions, BidManagerActionsFactory.previewBid({ label: 'Preview Initial Bid' }), bidReport);
        addAction(primaryActions, BidManagerActionsFactory.createEditResponse(), bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.uploadResponses(), bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'RESPONDED':
        addAction(primaryActions, BidManagerActionsFactory.previewBid({ label: 'Preview Initial Bid' }), bidReport);
        addAction(primaryActions, BidManagerActionsFactory.updateResponse, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'FINAL_AGREEMENT':
        addAction(primaryActions, BidManagerActionsFactory.viewFinalAgreement, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.markRatesAsLoaded, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.markRatesAsNotLoaded, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid({ label: 'Preview Initial Bid' }), bidReport);
        addAction(otherActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'NEGOTIATION_SENT':
        addAction(primaryActions, BidManagerActionsFactory.openNegotiations, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.sendNoLongerInterested, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.uploadNegotiations, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid({ label: 'Preview Initial Bid' }), bidReport);
        addAction(otherActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'NEGOTIATION_RESPONDED':
        addAction(primaryActions, BidManagerActionsFactory.openNegotiations, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.reUploadNegotiations, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid({ label: 'Preview Initial Bid' }), bidReport);
        addAction(otherActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'NEGOTIATION_FINALIZED':
      case 'NO_THANK_YOU_PENDING':
      case 'FINAL_AGREEMENT_PENDING':
        addAction(primaryActions, BidManagerActionsFactory.openNegotiations, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.sendNoLongerInterested, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid({ label: 'Preview Initial Bid' }), bidReport);
        addAction(otherActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'NO_THANK_YOU':
        addAction(primaryActions, BidManagerActionsFactory.viewNoThankYouLetter, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid({ label: 'Preview Initial Bid' }), bidReport);
        addAction(otherActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'NO_LONGER_INTERESTED':
        addAction(primaryActions, BidManagerActionsFactory.previewBid({ label: 'Preview Initial Bid' }), bidReport);
        addAction(primaryActions, BidManagerActionsFactory.openNegotiations, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'BUYER_DELETED':
        addAction(primaryActions, BidManagerActionsFactory.removeDeletedBids, bidReport);
        break;

      case 'COMPETITIVE_SENT':
      case 'COMPETITIVE_RECEIVED':
        addAction(primaryActions, BidManagerActionsFactory.viewCompetitiveBid, bidReport);
        addAction(primaryActions, BidManagerActionsFactory.declineCompetitiveBid, bidReport);
        break;

      case 'COMPETITIVE_DECLINED':
        addAction(primaryActions, BidManagerActionsFactory.viewCompetitiveBid, bidReport);
        break;

      case 'COMPETITIVE_RECEIVED_ACCEPTED':
        addAction(primaryActions, BidManagerActionsFactory.editCompetitiveBidResponse, bidReport);
        addAction(primaryActions, BidManagerActionsFactory.sendCompetitiveBidResponse, bidReport);
        addAction(otherActions, BidManagerActionsFactory.viewCompetitiveBid, bidReport);
        break;

      case 'COMPETITIVE_RESPONDED':
        addAction(primaryActions, BidManagerActionsFactory.viewCompetitiveBid, bidReport);
        addAction(primaryActions, BidManagerActionsFactory.updateResponse, bidReport);
        break;

      case 'COMPETITIVE_REFUSED':
        addAction(primaryActions, BidManagerActionsFactory.removeRefusedCompetitiveBid, bidReport);
        addAction(otherActions, BidManagerActionsFactory.viewCompetitiveBid, bidReport);
        break;

      default:
    }

    return {
      primary: primaryActions,
      secondary: secondaryActions,
      other: otherActions,
      rfp: rfpActions
    };
  }

  function getHmcHotelRfpActions(bidReport) {
    const primaryActions = [], secondaryActions = [], otherActions = [], rfpActions = [];

    switch (bidReport.statuses[0]) {

      case 'CREATED':
        break;

      case 'SENT':
        addAction(primaryActions, BidManagerActionsFactory.previewBid({ label: 'View Bid' }), bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'RECEIVED': {
        addAction(otherActions, BidManagerActionsFactory.previewBid({label: 'Preview Initial Bid'}), bidReport);
        addAction(otherActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;
      }
      case 'WITHDRAWN':
        addAction(otherActions, BidManagerActionsFactory.previewBid({ label: 'Preview Initial Bid' }), bidReport);
        addAction(otherActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'NOT_INTERESTED':
        addAction(primaryActions, BidManagerActionsFactory.previewBid({ label: 'Preview Initial Bid' }), bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'RESPONDED':
        addAction(primaryActions, BidManagerActionsFactory.previewBid({ label: 'Preview Initial Bid' }), bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'FINAL_AGREEMENT':
        addAction(primaryActions, BidManagerActionsFactory.viewFinalAgreement, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid({ label: 'Preview Initial Bid' }), bidReport);
        addAction(otherActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'NEGOTIATION_SENT':
        if(bidReport.isCompetitive) addAction(primaryActions, BidManagerActionsFactory.openNegotiationsPanel, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid({ label: 'Preview Initial Bid' }), bidReport);
        addAction(otherActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'NEGOTIATION_RESPONDED':
        if(bidReport.isCompetitive) addAction(primaryActions, BidManagerActionsFactory.openNegotiationsPanel, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid({ label: 'Preview Initial Bid' }), bidReport);
        addAction(otherActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'NEGOTIATION_FINALIZED':
      case 'NO_THANK_YOU_PENDING':
      case 'FINAL_AGREEMENT_PENDING':
        addAction(primaryActions, BidManagerActionsFactory.openNegotiationsPanel, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid({ label: 'Preview Initial Bid' }), bidReport);
        addAction(otherActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'NO_THANK_YOU':
        addAction(primaryActions, BidManagerActionsFactory.viewNoThankYouLetter, bidReport);
        addAction(otherActions, BidManagerActionsFactory.previewBid({ label: 'Preview Initial Bid' }), bidReport);
        addAction(otherActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'NO_LONGER_INTERESTED':
        addAction(primaryActions, BidManagerActionsFactory.previewBid({ label: 'Preview Initial Bid' }), bidReport);
        addAction(primaryActions, BidManagerActionsFactory.openNegotiationsPanel, bidReport);
        addAction(secondaryActions, BidManagerActionsFactory.viewBidPackage, bidReport);
        addAction(otherActions, BidManagerActionsFactory.exportBidPackage, bidReport);
        break;

      case 'BUYER_DELETED':
        addAction(primaryActions, BidManagerActionsFactory.removeDeletedBids, bidReport);
        break;

      case 'COMPETITIVE_SENT':
      case 'COMPETITIVE_RECEIVED':
        addAction(primaryActions, BidManagerActionsFactory.viewCompetitiveBid, bidReport);
        break;

      case 'COMPETITIVE_DECLINED':
        addAction(primaryActions, BidManagerActionsFactory.viewCompetitiveBid, bidReport);
        break;

      case 'COMPETITIVE_RECEIVED_ACCEPTED':
        addAction(primaryActions, BidManagerActionsFactory.editCompetitiveBidResponse, bidReport);
        addAction(primaryActions, BidManagerActionsFactory.sendCompetitiveBidResponse, bidReport);
        addAction(otherActions, BidManagerActionsFactory.viewCompetitiveBid, bidReport);
        break;

      case 'COMPETITIVE_RESPONDED':
        addAction(primaryActions, BidManagerActionsFactory.viewCompetitiveBid, bidReport);
        addAction(primaryActions, BidManagerActionsFactory.updateResponse, bidReport);
        break;

      case 'COMPETITIVE_REFUSED':
        addAction(primaryActions, BidManagerActionsFactory.removeRefusedCompetitiveBid, bidReport);
        addAction(otherActions, BidManagerActionsFactory.viewCompetitiveBid, bidReport);
        break;

      default:
    }

    return {
      primary: primaryActions,
      secondary: secondaryActions,
      other: otherActions,
      rfp: rfpActions
    };
  }
}

